var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    false
      ? _c(
          "div",
          { staticClass: "view-main" },
          [
            _c("div", { staticClass: "view-detail" }, [
              _c("p", { staticClass: "p-title" }, [
                _c("i", { staticClass: "fenge" }),
                _vm._v("\n        合同列表\n        "),
                _c("span", { staticClass: "temp" }, [
                  _vm._v("共 "),
                  _c("span", { staticClass: "tempNo" }, [
                    _vm._v(_vm._s(_vm.contractList.length))
                  ]),
                  _vm._v(" 份")
                ])
              ]),
              _c(
                "ul",
                { staticClass: "contract-list" },
                _vm._l(_vm.contractList, function(item, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      on: {
                        click: function($event) {
                          return _vm.showDetail(item, index)
                        }
                      }
                    },
                    [
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !item.read,
                            expression: "!item.read"
                          }
                        ],
                        attrs: { src: "/images/weidu.png", alt: "" }
                      }),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: item.read,
                            expression: "item.read"
                          }
                        ],
                        attrs: { src: "/images/yidu.png", alt: "" }
                      })
                    ]
                  )
                }),
                0
              )
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.unableSign,
                    expression: "!unableSign"
                  }
                ],
                staticClass: "option-main"
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "sign-footer",
                    on: {
                      click: function($event) {
                        return _vm.getQrcode()
                      }
                    }
                  },
                  [_c("div", { staticClass: "sign-btn" }, [_vm._v("立即签署")])]
                )
              ]
            ),
            _vm.signInfo
              ? _c(
                  "el-dialog",
                  {
                    staticClass: "sign-login",
                    attrs: {
                      visible: _vm.signLoginInfo.visibleSignLogin,
                      "close-on-click-modal": false,
                      "modal-append-to-body": "",
                      width: "550px",
                      "show-close": false
                    },
                    on: {
                      "update:visible": function($event) {
                        return _vm.$set(
                          _vm.signLoginInfo,
                          "visibleSignLogin",
                          $event
                        )
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "dialog-box" },
                      [
                        _c(
                          "div",
                          { staticClass: "nav-bar" },
                          [
                            _vm.signInfo.mobileList &&
                            _vm.signInfo.mobileList.length
                              ? [
                                  _c(
                                    "a",
                                    {
                                      class:
                                        _vm.signLoginInfo.navBar === "mobile"
                                          ? "active"
                                          : "",
                                      attrs: { href: "javascript:void (0)" },
                                      on: {
                                        click: function($event) {
                                          return _vm.switchSignLoginType(
                                            "mobile"
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("手机验证")]
                                  )
                                ]
                              : _vm._e(),
                            _vm.signInfo.emailList &&
                            _vm.signInfo.emailList.length
                              ? [
                                  _c(
                                    "a",
                                    {
                                      class:
                                        _vm.signLoginInfo.navBar === "email"
                                          ? "active"
                                          : "",
                                      attrs: { href: "javascript:void (0)" },
                                      on: {
                                        click: function($event) {
                                          return _vm.switchSignLoginType(
                                            "email"
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("邮箱验证")]
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        ),
                        _c(
                          "el-form",
                          {
                            staticClass: "sign-login__form",
                            attrs: {
                              model: _vm.signLoginInfo,
                              size: "small",
                              "label-width": "120px"
                            }
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { "label-width": "80px" } },
                              [
                                _c("h5", [
                                  _vm._v("为保障您的签署安全，请输入验证码。")
                                ])
                              ]
                            ),
                            _vm.signLoginInfo.navBar === "mobile"
                              ? [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "手机号" } },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "select",
                                          on: {
                                            change: function($event) {
                                              return _vm.handleSignLoginUserChange(
                                                "mobile"
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.signLoginInfo.mobilePhone,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.signLoginInfo,
                                                "mobilePhone",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "signLoginInfo.mobilePhone"
                                          }
                                        },
                                        [
                                          _vm._l(
                                            _vm.signInfo.mobileList,
                                            function(item, i) {
                                              return _vm.signInfo.mobileList
                                                ? [
                                                    _c("el-option", {
                                                      key: i,
                                                      attrs: {
                                                        value: item.mobile,
                                                        label: item.mobile
                                                      }
                                                    })
                                                  ]
                                                : _vm._e()
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                ]
                              : _vm._e(),
                            _vm.signLoginInfo.navBar === "email"
                              ? [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "邮箱" } },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "select",
                                          on: {
                                            chage: function($event) {
                                              return _vm.handleSignLoginUserChange(
                                                "email"
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.signLoginInfo.email,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.signLoginInfo,
                                                "email",
                                                $$v
                                              )
                                            },
                                            expression: "signLoginInfo.email"
                                          }
                                        },
                                        [
                                          _vm._l(
                                            _vm.signInfo.emailList,
                                            function(item, i) {
                                              return _vm.signInfo.emailList
                                                ? [
                                                    _c("el-option", {
                                                      key: i,
                                                      attrs: {
                                                        value: item.email,
                                                        label: item.email
                                                      }
                                                    })
                                                  ]
                                                : _vm._e()
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                ]
                              : _vm._e(),
                            _vm.signLoginInfo.isImgCode
                              ? _c(
                                  "el-form-item",
                                  { attrs: { label: "图形验证码" } },
                                  [
                                    _c(
                                      "el-row",
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: "图形验证码"
                                              },
                                              model: {
                                                value:
                                                  _vm.signLoginInfo.imgCode,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.signLoginInfo,
                                                    "imgCode",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "signLoginInfo.imgCode"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 9, offset: 3 } },
                                          [
                                            _c("img-auth", {
                                              ref: "refreshQRCode00",
                                              attrs: {
                                                size: "small",
                                                "verify-type": 20,
                                                "img-token":
                                                  _vm.signLoginInfo.imgToken
                                              },
                                              on: {
                                                "update:imgToken": function(
                                                  $event
                                                ) {
                                                  return _vm.$set(
                                                    _vm.signLoginInfo,
                                                    "imgToken",
                                                    $event
                                                  )
                                                },
                                                "update:img-token": function(
                                                  $event
                                                ) {
                                                  return _vm.$set(
                                                    _vm.signLoginInfo,
                                                    "imgToken",
                                                    $event
                                                  )
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "el-form-item",
                              { attrs: { label: "验证码" } },
                              [
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 12 } },
                                      [
                                        _c("el-input", {
                                          attrs: { placeholder: "验证码" },
                                          model: {
                                            value: _vm.signLoginInfo.valicode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.signLoginInfo,
                                                "valicode",
                                                $$v
                                              )
                                            },
                                            expression: "signLoginInfo.valicode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 9, offset: 3 } },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              disabled: _vm.countdownInfo.start,
                                              type: "success"
                                            },
                                            on: { click: _vm.signLoginSendCode }
                                          },
                                          [
                                            _vm.countdownInfo.start
                                              ? [
                                                  _c("countdown", {
                                                    attrs: {
                                                      start:
                                                        _vm.countdownInfo.start
                                                    },
                                                    on: {
                                                      "on-finish":
                                                        _vm.handleCountdownFinish
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.countdownInfo.time,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.countdownInfo,
                                                          "time",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "countdownInfo.time"
                                                    }
                                                  })
                                                ]
                                              : [_vm._v("发送验证码")]
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { staticClass: "protocol" },
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    attrs: { checked: true },
                                    model: {
                                      value: _vm.checked,
                                      callback: function($$v) {
                                        _vm.checked = $$v
                                      },
                                      expression: "checked"
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticStyle: { color: "#666666" } },
                                      [_vm._v("我已阅读")]
                                    ),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "showAgreement",
                                        staticStyle: { color: "#409eff" },
                                        attrs: { href: "javascript:void(0)" },
                                        on: {
                                          click: function($event) {
                                            _vm.showServiceProtocol = true
                                          }
                                        }
                                      },
                                      [_vm._v("《君子签服务协议》")]
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { staticClass: "text-center" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn__submit",
                                    attrs: { type: "danger" },
                                    on: { click: _vm.userSignLoginCheck }
                                  },
                                  [_vm._v("开始签署")]
                                )
                              ],
                              1
                            )
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ]
                )
              : _vm._e(),
            _c(
              "el-dialog",
              {
                staticClass: "add-enidence",
                attrs: { visible: _vm.visibleQrcode, width: "340px" },
                on: {
                  "update:visible": function($event) {
                    _vm.visibleQrcode = $event
                  }
                }
              },
              [
                _c("qrcode-vue", {
                  key: "evidence",
                  attrs: { value: _vm.qrcodeUrl, size: 300, leave: "H" }
                }),
                _c(
                  "p",
                  {
                    staticClass: "text-center",
                    staticStyle: { "font-size": "12px", margin: "0" }
                  },
                  [_vm._v("\n        请扫码在手机上完成签署\n      ")]
                )
              ],
              1
            ),
            _c("service-protocol", {
              attrs: { visible: _vm.showServiceProtocol },
              on: {
                "update:visible": function($event) {
                  _vm.showServiceProtocol = $event
                }
              }
            })
          ],
          1
        )
      : _vm._e(),
    _c(
      "div",
      { staticClass: "view-main-h5" },
      [
        _c("iframe", {
          staticClass: "iframe-sty",
          attrs: {
            src:
              _vm.GlobalConfig.domain.junziqianH5Op +
              "/derong/signInfo/viewDetail_new?" +
              _vm.qs.stringify(_vm.query),
            frameborder: ""
          }
        }),
        _c(
          "el-dialog",
          {
            staticClass: "pre-img-box-sty",
            attrs: { visible: _vm.preVisi, width: "60%" },
            on: {
              "update:visible": function($event) {
                _vm.preVisi = $event
              }
            }
          },
          [
            _c(
              "div",
              { staticClass: "dia-body" },
              [
                _vm._l(_vm.preImgUrlList, function(img, i) {
                  return [
                    _c("img", {
                      key: i,
                      staticClass: "pre-img",
                      attrs: { src: img.url }
                    }),
                    _c("p", { key: i, staticClass: "page-item" }, [
                      _vm._v(
                        _vm._s(img.page + " / " + _vm.preImgUrlList.length)
                      )
                    ])
                  ]
                })
              ],
              2
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-703350bb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-703350bb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/derong/signInfo/viewDetail.vue
// module id = yGfd
// module chunks = 124